// extracted by mini-css-extract-plugin
export default {"main":"ThankYouPage_main__8fJ7E","centeredbox":"ThankYouPage_centeredbox__GUCSm","spacing":"ThankYouPage_spacing__8dY33"};